module.exports = __webpack_public_path__ + "img/adv001.478e16d2.svg";